import React, { useEffect, useState } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./AdminUserFeedback.module.css";
import StarRatings from "react-star-ratings";
import moment from "moment";
import PropTypes from "prop-types";

export const AdminUserFeedback = ({ data }) => {
  return (
    <div
      className={classes.feedbackBox}
      style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
    >
      <StarRatings
        numberOfStars={5}
        rating={data?.rating}
        starDimension={"24px"}
        starSpacing={"4px"}
        starRatedColor={Colors.mainShadeOfRed}
        starEmptyColor={Colors.neutralShadesOfGainsboro}
      />
      <h6
        style={{
          fontFamily: "inter-600",
          lineHeight: "150%",
          fontSize: "16px",
          color: Colors.neutralShadesOfNero,
        }}
      >
        {data?.title}
      </h6>
      <p
        className={classes.description}
        style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
      >
        {data?.description}
      </p>
      <div className="d-flex align-items-center">
        <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          {data?.displayName}
        </span>
        <span className={classes.break} style={{ background: "#9e9e9e" }} />
        <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          {data?.createdAt}
        </span>
      </div>
    </div>
  );
};

AdminUserFeedback.propTypes = {
  data: PropTypes.object,
};
AdminUserFeedback.defaultProps = {
  data: {
    createdAt: "June 14, 2021",
    title: "New Sport added!",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    displayName: "Jessica M",
    rating: 4,
  },
};
